import { Flex } from "antd";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useAtom } from "jotai";
import { isLoginAtom } from "src/atoms/authAtom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { refreshAccessKey } from "src/api/authApi";
import { getUserProfile } from "src/api/userApi";
import { setTokenData } from "src/util/auth.util";
import PWADrawer from "components/PWADrawer/PWADrawer";
interface mainLayoutProps {
  children: React.ReactNode;
}
const MainWrapper = styled.div`
  width: 420px;
  height: 100dvh;
  box-sizing: border-box;
  position: relative;
  overflow-x: hidden;
`;

let refreshKeyTimeout = 0;

function MainLayout({ children }: mainLayoutProps) {
  const [isLogin] = useAtom(isLoginAtom);
  const { mutate: mutateKey } = useMutation({
    mutationFn: () => refreshAccessKey(),
  });
  useQuery({
    queryKey: ["profile"],
    queryFn: getUserProfile,
    enabled: Boolean(isLogin),
  });
  //  const refreshTimeout = () => {
  //   let expire =
  //     Number(localStorage.getItem("expire-token")) - (Date.now() + 60_000);
  //   expire = expire > 5000 ? expire : 5000;
  //   console.log(expire + "%cexpire countDonw", "color: red");

  //   refreshKeyTimeout = setTimeout(() => {
  //     //mutateKey();
  //     //refreshTimeout();
  //   }, expire);
  // };

  useEffect(() => {
    if (isLogin) {
      // refreshTimeout();
      return () => {
        clearInterval(refreshKeyTimeout);
      };
    }
  }, [isLogin]);

  useEffect(() => {
    const preventScroll = (e: TouchEvent) => {
      e.preventDefault();
    };
    document.body.addEventListener("touchmove", preventScroll);

    return () => {
      document.body.removeEventListener("touchmove", preventScroll);
    };
  }, []);

  return (
    <Flex justify="center">
      <MainWrapper>{children}</MainWrapper>
      <PWADrawer />
    </Flex>
  );
}

export default MainLayout;
